/*
=========================================================
* Material Kit 2 React - v2.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-kit-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";

// Material Kit 2 React components
import MKBox from "components/MKBox";

// Material Kit 2 React examples
import DefaultInfoCard from "examples/Cards/InfoCards/DefaultInfoCard";

function CheticampByElectionInformation() {
  return (
    <MKBox component="section" py={12}>
      <Container>
        <Grid container spacing={3} alignItems="center">
          <Grid item xs={12} lg={12} sx={{ ml: "auto", mt: { xs: 3, lg: 0 } }}>
            <DefaultInfoCard
              //icon="info"
              title="Chéticamp-Margarees-Pleasant Bay By-election  "
              description={
                <>
                <h4>Held June 23, 2026</h4>
                <br/>
                <h3>Post Election Reporting</h3>

                <p>Summary of Votes and Statistics (non-financial)</p>
                <ul style={{ paddingLeft: "40px" }}>
                  <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/PostElection/Chéticamp-Margarees-Pleasant Bay 2026 byelection_ReportNonFinanacial_EN_FINAL.pdf">Report of the Chief Electoral Officer on the Proceedings of the Chéticamp-Margarees-Pleasant Bay By-election</a></li>
                  <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/PostElection/Chéticamp-Margarees-Pleasant Bay 2026 byelection_ReportNonFinanacial_FR_FINAL.pdf">Rapport de la directrice générale des élections sur le déroulement de l’élection partielle de la circonscription de Chéticamp-Margarees-Pleasant Bay</a></li>
                </ul>
                <br/>
                <p>Financial Information and Statistics</p>
                <br/>
                <p>Please note: The second post-election report for the Chéticamp-Margarees-Pleasant Bay by-election, which is related to the financial information and statistics, will be released in the coming months.</p>
                <br/>
                <p><strong>Chéticamp-Margarees-Pleasant Bay By-election Expenses</strong></p>

                  <ul style={{ paddingLeft: "40px" }}>
                    <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/Candidates/2026_Chéticamp-Margarees-Pleasant Bay_LIB_Cormier, Denis_Expenses.pdf">Denis Cormier (LIberal) Expenses</a> (PDF)</li>                            
                 
                        <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/Candidates/2026_Chéticamp-Margarees-Pleasant Bay_NDP_Poirier, Trevor_Expenses.pdf">Trevor Poirier (NSNDP) Expenses</a> (PDF)</li>
                        <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/Candidates/2026_Chéticamp-Margarees-Pleasant Bay_PC_Bourgeois, Claude_Expenses.pdf">Claude Bourgeois (PC) Expenses</a> (PDF)</li>           
                         </ul>

<br/>
                  <p><strong>Chéticamp-Margarees-Pleasant Bay Registered Party Expenses</strong></p>

                    <ul style={{ paddingLeft: "40px" }}>
                          <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/Parties/2026_Chéticamp-Margarees-Pleasant Bay By-election_Party Expense_PC.pdf">Progressive Conservative Association of Nova Scotia</a> (PDF)</li>
                          <li><a href="/files/Chéticamp-Margarees-Pleasant Bay By-election/Expenses/Parties/2026_Chéticamp-Margarees-Pleasant Bay By-election_Party Expense_LIB.pdf">Liberal Party of Nova Scotia</a> (PDF)</li>
                    </ul>
<br/>

          <p><strong>Candidate and Party Spending Limits for the Chéticamp-Margarees-Pleasant Bay by-election</strong></p>

            The following amounts are determined according to the Elections Act (updated to include CPI adjustments):
            <br/><br/>
            <b>Final Number of Electors: 4,002 (as of July 27, 2026)</b>
            <br/>
            <b>Candidate Spending Limit*: $32,343.47</b>
            <br/>
            <b>Candidate Reimbursement Limit: $8,085.87</b>
            <br/>
            <b>Registered Party Spending Limit: $8,086.35</b>
            <br/>
            <b>Third Party Spending Limit: $2,825.81</b>
            <br/><br/>
          <i>*The candidate spending limit for the Chéticamp-Margarees-Pleasant Bay by-election has been adjusted based on the number of electors on the Final List of Electors as of July 27, 2026.</i> <br/>

<br/>

          <p><strong>Financial Reporting Deadlines for the Chéticamp-Margarees-Pleasant Bay by-election</strong></p>

            Financial reports from the candidates, registered political parties, and third party advertisers, are due in the weeks and months ahead. All reports must be sent to the Chief Electoral Officer.
            <br/>
            Candidate tax receipts are due 30 days after election day on July 23, 2026.
            <br/>
            Candidate financial reports, including audit reports, are due (80 days after writ) on September 21, 2026.
            <br/>
            It is also important to remember that there are fines of $50 per day for late candidate reports.
            <br/>
            Registered party financial reports are due (120 days after Writ) on October 31, 2026.
            <br/>
            Third party election advertising reports are due on October 23, 2026.


                </>
              }
            />
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default CheticampByElectionInformation;
